import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const CANONICAL_WHATSAPP_NUMBER_PATTERN = /^\+[1-9]\d{5,14}$/;
const INTERNATIONAL_NUMBER_PATTERN = /^(?:\+\s*|00\s*)[1-9][\d\s()-]*$/;
const OPTIONAL_GERMAN_TRUNK_PREFIX_PATTERN = /^(?:\+\s*49|00\s*49)\s*\(\s*0\s*\)/;
const OPTIONAL_TRUNK_MARKER_PATTERN = /\(\s*0\s*\)/g;

function hasBalancedParentheses(value: string): boolean {
  let depth = 0;
  for (const character of value) {
    if (character === '(') depth += 1;
    if (character === ')') {
      depth -= 1;
      if (depth < 0) return false;
    }
  }
  return depth === 0;
}

export function normalizeWhatsAppNumber(value: unknown): string | null {
  if (typeof value !== 'string') return null;

  const input = value.trim();
  if (!input || !INTERNATIONAL_NUMBER_PATTERN.test(input) || !hasBalancedParentheses(input)) {
    return null;
  }

  const optionalTrunkMarkers = input.match(OPTIONAL_TRUNK_MARKER_PATTERN) || [];
  const hasSafeGermanTrunkPrefix = OPTIONAL_GERMAN_TRUNK_PREFIX_PATTERN.test(input);
  if (optionalTrunkMarkers.length && (!hasSafeGermanTrunkPrefix || optionalTrunkMarkers.length !== 1)) {
    return null;
  }

  const withoutOptionalTrunkPrefix = hasSafeGermanTrunkPrefix
    ? input.replace(OPTIONAL_GERMAN_TRUNK_PREFIX_PATTERN, (match) => match.replace(/\(\s*0\s*\)/, ''))
    : input;
  const withoutPrefix = withoutOptionalTrunkPrefix.startsWith('+')
    ? withoutOptionalTrunkPrefix.slice(1)
    : withoutOptionalTrunkPrefix.slice(2);
  const digits = withoutPrefix.replace(/[\s()-]/g, '');
  const normalized = `+${digits}`;

  return CANONICAL_WHATSAPP_NUMBER_PATTERN.test(normalized) ? normalized : null;
}

export function whatsAppNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined || String(value).trim() === '') {
      return null;
    }

    return normalizeWhatsAppNumber(value) ? null : { invalidWhatsAppNumber: true };
  };
}
